import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import AddPaymentSchema from "../../utils/SchemasValidation/AddPaymentSchema";
import ValidateSchema from "../../helpers/ValidateSchema";
// import classes from "../../assets/styles/CustomURLModal.module.css";
import { MdClose } from "react-icons/md";
import FormInput from "../../components/Forms/FormInput";
import SecondLoader from "../../components/SecondLoader";
import { trackEvent } from "../../utils/mixpanel";
import { useLocation } from "react-router-dom";

const PaymentAddEditModal = ({
  loading,
  data,
  setSelectedData,
  handleSaveShowModal,
  handleCloseModal,
  show,
}) => {
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setSelectedData({ ...data, [name]: value });
  };

  // handle Validation
  const validateForm = () => {
    let newErrors = ValidateSchema(data, AddPaymentSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;
    return true;
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");
  const teamIdFromURL = searchParams.get("team_id");
  const userIdFromURL = searchParams.get("user_id");

  let source = "Function Page";
  if (dynamicQRCodeId) {
    source = "QR Code";
  } else if (teamIdFromURL && userIdFromURL) {
    source = "Team Member Function Page";
  }

  const handleAddUrl = async (e) => {
    const isNew = data?.isNew === true;

    const successMessage = isNew
      ? `Payment Link successfully added from ${source}`
      : `Payment Link successfully updated from ${source}`;

    if (!validateForm()) return;
    await handleSaveShowModal(data);

    trackEvent(
      isNew
        ? `Payment Link successfully added from ${source}`
        : `Payment Link successfully updated from ${source}`,
      {
        message: successMessage,
        source,
        dynamic_qr_code_id: dynamicQRCodeId,
        team_id: teamIdFromURL,
        user_id: userIdFromURL,
        data,
      }
    );
  };

  // Handle Update
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleCloseModal();
          setErrors({});
        }}
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header className="modalHeader d-flex justify-content-between">
          <span className="modalHeading">
            {data?.isNew ? "Add" : "Edit "} Payment Service
          </span>
          <div className="modalGradientCircle"></div>
          <MdClose
            onClick={() => {
              handleCloseModal();
              setErrors({});
            }}
            className="modalCloseBtn"
          />
        </Modal.Header>
        {loading ? (
          <SecondLoader />
        ) : (
          <>
            <Modal.Body>
              <div className="container-fluid px-3">
                <div className="form-group mb-3">
                  <label className="form-label" style={{ fontSize: "13px" }}>
                    Payment Service Type
                  </label>
                  {/* <div className="input-group globalInputWithIcon"> */}
                  <select
                    className="form-select form-control"
                    name="payment_type"
                    value={data.payment_type}
                    onChange={handleChange}
                  >
                    <option value="">Select Payment Service Type</option>
                    <option value="cash_app">Cash App</option>
                    <option value="venmo">Venmo</option>
                    <option value="custom_payment">Other</option>
                  </select>
                  {/* </div> */}
                  {errors.payment_type && (
                    <span className="text-danger small fw-semibold d-block mt-1">
                      {errors.payment_type}
                    </span>
                  )}
                </div>

                <div className="mb-3">
                  <FormInput
                    type="text"
                    label="Title"
                    placeholder="Enter Title"
                    name="title"
                    value={data.title}
                    onChange={handleChange}
                    error={errors?.title}
                  />
                </div>

                <div className="mb-2">
                  <FormInput
                    type="text"
                    label="URL"
                    placeholder="Enter URL"
                    name="url_path"
                    value={data.url_path}
                    onChange={handleChange}
                    error={errors?.url_path}
                  />
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <div className="btnWrapper">
                <Button
                  type="button"
                  onClick={() => {
                    handleCloseModal();
                    setErrors({});
                  }}
                  variant="outline-primary"
                  className="cancelBtn mx-3"
                >
                  Cancel
                </Button>

                <Button
                  variant="primary"
                  type="button"
                  onClick={handleAddUrl}
                  // onClick={() => {
                  //   handleAddUrl();
                  //   // handleTracking("Payment Service Added");
                  // }}
                  className="saveBtn"
                >
                  Save
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default PaymentAddEditModal;
